<template>
    <div class="sign-in">
        <login-form
            ref="loginForm"
            :email="email"
            :password="password"
            @loginByFacebook="loginByFacebook"
            @loginByPassword="loginByPassword"
        ></login-form>
    </div>

</template>

<style lang="scss">
    .sign-in {
        max-width: 300px;
        margin: 30px auto;
        border: 1px solid #989898;
        padding: 20px;

        webkit-box-shadow: 0px 0px 30px 0px rgba(122,122,122,1);
        -moz-box-shadow: 0px 0px 30px 0px rgba(122,122,122,1);
        box-shadow: 0px 0px 30px 0px rgba(122,122,122,1);

        border-radius: 5px;
    }
</style>

<script>
import LoginForm from '@/components/auth/LoginForm.vue';

export default {
  data() {
    return {
      email: '',
      password: '',
    };
  },

  methods: {
    resetForm() {
      this.$refs.loginForm.reset();
    },

    loginByPassword(data) {
      this.$store.dispatch('signInByPassword', {
        email: data.email,
        password: data.password,
      }).then(() => {
        this.resetForm();
        this.$router.replace('/');
      });
    },

    loginByFacebook() {
      this.$store.dispatch('signInByFacebook').then(() => {
        this.$router.replace('/');
      });
    },
  },

  components: {
    LoginForm,
  },
};
</script>
